module.exports = __webpack_public_path__ + "img/kj_ico2.bbc187ef.png";